import React from 'react'
import styled from 'styled-components'
import Text from '../atoms/Text'

const Container = styled.div`
  width: 100%;
  padding: 16px;
  background-color:${(props) => props.theme.colors.neutral[100]};
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  border-radius: 20px;
  border: 1px solid ${(props) => props.theme.colors.neutral[300]};
`

const SummaryCard = ({ label, value, unit, icon: Icon, color }) => {
  return (
    <Container>
      <Icon sx={{ fontSize: 24, color: color}}/>
      <Text variant="body2" weight="medium" color="alternative">{label}</Text>
      <>
        <Text variant="headline2" weight="bold">{value}</Text>
        <Text variant="body2" color="alternative"> {unit}</Text>
      </>
    </Container>
  )
}

export default SummaryCard
